import type { JSONSchemaType } from 'ajv';

import { ApiPatchOperation, IdentityProvider, UserRole } from '../types';

interface CreateUserPayload {
  firstName: string;
  lastName: string;
  role: UserRole.Admin | UserRole.Superadmin | UserRole.User;
  email: string;
  teams: number[];
  identityProvider: IdentityProvider;
}

interface UpdateUserPayload {
  operation: ApiPatchOperation.UserUpdate;
  firstName: string;
  lastName: string;
  role: UserRole;
  email: string;
  identityProvider: IdentityProvider;
  teams: number[];
}

export const createUserPayloadSchema: JSONSchemaType<CreateUserPayload> = {
  type: 'object',
  properties: {
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    role: { type: 'string', enum: [UserRole.Admin, UserRole.Superadmin, UserRole.User] },
    teams: { type: 'array', items: { type: 'number' } },
    identityProvider: { type: 'string', enum: [IdentityProvider.External, IdentityProvider.Internal] },
  },
  required: ['firstName', 'lastName', 'email', 'role'],
  additionalProperties: false,
};

export const updateUserPayloadSchema: JSONSchemaType<UpdateUserPayload> = {
  type: 'object',
  properties: {
    operation: { type: 'string', const: ApiPatchOperation.UserUpdate },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    role: { type: 'string', enum: [UserRole.Admin, UserRole.Superadmin, UserRole.User] },
    teams: { type: 'array', items: { type: 'number' } },
    identityProvider: { type: 'string', enum: [IdentityProvider.External, IdentityProvider.Internal] },
  },
  required: ['operation', 'firstName', 'lastName', 'role'],
  additionalProperties: false,
};
